export const PRIMARY_BUTTON_BASE_CSS_VARS = {
  "theme-website-primary-button-default-text-color":
    "var(--theme-website-color-1)",
  "theme-website-primary-button-hover-text-color":
    "var(--theme-website-color-1)",
  "theme-website-primary-button-default-background-color":
    "var(--theme-website-color-5)",
  "theme-website-primary-button-hover-background-color":
    "var(--theme-website-color-6)",
  "theme-website-primary-button-default-border-color":
    "var(--theme-website-color-5)",
  "theme-website-primary-button-hover-border-color":
    "var(--theme-website-color-6)",
  "theme-website-primary-button-default-font-family": "InterVariable",
  "theme-website-primary-button-hover-font-family": "InterVariable",
  "theme-website-primary-button-default-font-weight": "500",
  "theme-website-primary-button-hover-font-weight": "500",
  "theme-website-primary-button-default-font-size": "1rem",
  "theme-website-primary-button-hover-font-size": "1rem",
  "theme-website-primary-button-default-line-height": "1.5",
  "theme-website-primary-button-hover-line-height": "1.5",
  "theme-website-primary-button-default-letter-spacing": "-0.01em",
  "theme-website-primary-button-hover-letter-spacing": "-0.01em",
  "theme-website-primary-button-default-border-width": "1px",
  "theme-website-primary-button-hover-border-width": "1px",
  "theme-website-primary-button-padding-top": "12",
  "theme-website-primary-button-padding-bottom": "12",
  "theme-website-primary-button-padding-left": "24",
  "theme-website-primary-button-padding-right": "24",
  "theme-website-primary-button-default-shadow": "none",
  "theme-website-primary-button-hover-shadow": "none",
  "theme-website-primary-button-default-border-left-top-radius": "30",
  "theme-website-primary-button-hover-border-left-top-radius": "30",
  "theme-website-primary-button-default-border-left-bottom-radius": "30",
  "theme-website-primary-button-hover-border-left-bottom-radius": "30",
  "theme-website-primary-button-default-border-right-top-radius": "30",
  "theme-website-primary-button-hover-border-right-top-radius": "30",
  "theme-website-primary-button-default-border-right-bottom-radius": "30",
  "theme-website-primary-button-hover-border-right-bottom-radius": "30",
};
